module.exports = __webpack_public_path__ + "img/hr-sand-decal-11.c0683b92.png";